import React, { FunctionComponent, ReactNode, useEffect, useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import { Box, makeStyles, withStyles } from "@mui/material";
import "./StepperNavigation.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { getMemberRegistrationStatusByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../Helpers/Network/APICalls";

const StepperNavigation = (props) => {
  // const [activeStepCount, setActiveStepCount] = React.useState(0);
  // const [skip, setSkip] = React.useState(new Set());

  const { steps, navigationBox, activeStep, directStep } = props;

  // const optionalStep = (step) => {
  //   return step;
  // };

  // const skipStep = (step) => {
  //   return skip.has(step);
  // };

  // const handleStepNext = () => {
  //   let newSkipped = skip;
  //   if (skipStep(activeStepCount)) {
  //     newSkipped = new Set(newSkipped.values());
  //     newSkipped.delete(activeStepCount);
  //   }

  //   setActiveStepCount((prevActiveStep) => prevActiveStep + 1);
  //   setSkip(newSkipped);
  // };

  // const handleStepBack = () => {
  //   setActiveStepCount((prevActiveStep) => prevActiveStep - 1);
  // };

  // const handleStepSkip = () => {
  //   setActiveStepCount((prevActiveStep) => prevActiveStep + 1);
  //   setSkip((prevSkipped) => {
  //     const newSkipped = new Set(prevSkipped.values());
  //     newSkipped.add(activeStepCount);
  //     return newSkipped;
  //   });
  // };

  // const handleStepReset = () => {
  //   setActiveStepCount(0);
  // };

  // const getData = async () => {
  //   const getData = await APICall(getMemberRegistrationStatusByMemberId, { MemberId: MemberId });
  //   if (getData?.Data != null) {
  //     const statusId = getData.Data.StatusId;
  //     const IsMemberPersonalDetailsExists =
  //       getData.Data.IsMemberPersonalDetailsExists;
  //     const IsMemberWitnessDetailsExists =
  //       getData.Data.IsMemberWitnessDetailsExists;
  //     const IsMemberEmploymentDetailsExists =
  //       getData.Data.IsMemberEmploymentDetailsExists;
  //     const IsMemberNomineeDetailsExists =
  //       getData.Data.IsMemberNomineeDetailsExists;

  //   }

  //   // if ([
  //   //     ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
  //   //     ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
  //   //     ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
  //   //     ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
  //   //   ].includes(statusId)){

  //   // }

  //   // if ([
  //   //     ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
  //   //   ].includes(StatusId)){

  //   // }
  // }

  const muiCache = createCache({
    key: "mui",
    prepend: true,
  });

  const getMuiTheme = () =>
    createTheme({
      components: {
        // MuiStepIcon: {
        //   styleOverrides: {
        //     root: {
        //       transform: "scale(2)",
        //       color: "#DB233A",
        //     },
        //     active: {
        //       backgroundColor: "#DB233A",
        //     },
        //   },
        // },
      },
    });

  // const CustomStepIcon = (props) => {
  //   const { stepNumber, activeStep, completed } = props;
  //   return (
  //     <div
  //       style={{
  //         borderRadius: "10rem",
  //         backgroundColor:
  //           activeStep === stepNumber
  //             ? "#DB233A"
  //             : completed
  //             ? "#7AC143"
  //             : "#6D6E71",
  //       }}
  //     >
  //       <span>{stepNumber}</span>
  //     </div>
  //   );
  // };

  return (
    <div className="p-1">
      <div className="" style={{ marginLeft: "29%" }}>
        <CacheProvider value={muiCache}>
          <ThemeProvider theme={getMuiTheme()}>
            <Stepper
              activeStep={activeStep}
              nonLinear
              alternativeLabel
              sx={{
                mb: 3,
                width: "50%",
              }}
            >
              {steps.map((step, index) => {
                // const stepProps = {};
                // const labelProps = {};
                //   if (optionalStep(index)) {
                //     labelProps.optional = <h6 variant="body1">Optional</h6>;
                //   }
                //   if (skipStep(index)) {
                //     stepProps.completed = false;
                //   }
                return (
                  <Step
                    key={index}
                    // completed={step.completed}
                  >
                    {/* <StepButton
                      // {...labelProps}
                      // onClick={() => setActiveStepCount(index)}
                      onClick={() => directStep(index)}
                      icon={
                        <CustomStepIcon
                          stepNumber={index}
                          activeStep={activeStep}
                          completed={step.completed}
                        />
                      }
                    > {"#3ac73ad9"}
                      {step.label}
                    </StepButton> */}
                    <StepLabel
                      StepIconProps={{
                        style: {
                          transform: "scale(2)",
                          color: activeStep === index ? "#DB233A" : step.completed ? "#7AC143" : "#6D6E71",
                        },
                      }}
                      onClick={() => directStep(index)}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                          color: activeStep === index ? "#DB233A" : step.completed ? "#7AC143" : "#6D6E71",
                        }}
                      >
                        {step.label}
                      </span>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </ThemeProvider>
        </CacheProvider>
      </div>
      <Box>{navigationBox[activeStep]}</Box>

      {/* For Next Back Buttons */}
      {/* {activeStepCount === steps.length ? (
            <div>
              <h3 sx={{ mt: 4, mb: 2 }}>All done!</h3>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 4 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleStepReset}>Reset</Button>
              </Box>
            </div>
          ) : (
            <div>
              <h3 sx={{ mt: 2, mb: 1 }}>
                Step
                {activeStepCount + 1}
              </h3>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Button
                  color="primary"
                  disabled={activeStepCount === 0}
                  onClick={handleStepBack}
                  sx={{ mr: 1 }}
                >
                  Previous
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
                {optionalStep(activeStepCount) && (
                  <Button
                    color="primary"
                    onClick={handleStepSkip}
                    sx={{ mr: 1 }}
                  >
                    Skip
                  </Button>
                )}

                <Button onClick={handleStepNext}>
                  {activeStepCount === steps.length - 1 ? "Done" : "Next"}
                </Button>
              </Box>
            </div>
          )} */}
    </div>
  );
};

export default StepperNavigation;
